var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4058_74148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 4.66669C2 4.13625 2.21071 3.62755 2.58579 3.25247C2.96086 2.8774 3.46957 2.66669 4 2.66669H12C12.5304 2.66669 13.0391 2.8774 13.4142 3.25247C13.7893 3.62755 14 4.13625 14 4.66669V11.3334C14 11.8638 13.7893 12.3725 13.4142 12.7476C13.0391 13.1226 12.5304 13.3334 12 13.3334H4C3.46957 13.3334 2.96086 13.1226 2.58579 12.7476C2.21071 12.3725 2 11.8638 2 11.3334V4.66669Z",
    stroke: "#20262B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66602 6.66665C4.66602 7.02027 4.80649 7.35941 5.05654 7.60945C5.30659 7.8595 5.64573 7.99998 5.99935 7.99998C6.35297 7.99998 6.69211 7.8595 6.94216 7.60945C7.19221 7.35941 7.33268 7.02027 7.33268 6.66665C7.33268 6.31302 7.19221 5.97389 6.94216 5.72384C6.69211 5.47379 6.35297 5.33331 5.99935 5.33331C5.64573 5.33331 5.30659 5.47379 5.05654 5.72384C4.80649 5.97389 4.66602 6.31302 4.66602 6.66665Z",
    stroke: "#20262B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 5.33331H11.3333",
    stroke: "#20262B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 8H11.3333",
    stroke: "#20262B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66602 10.6667H11.3327",
    stroke: "#20262B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4058_74148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.79cb21069bf709e842b6fc3b356bb170.svg";
export { ForwardRef as ReactComponent };